module.exports = __webpack_public_path__ + "static/img/in.4a4a57bc.png";